import { Paper, Grid, Modal, Typography, Box } from '@mui/material';
import React, { useState, useEffect, useContext } from 'react';
import SearchBar from '../components/SearchBar';
import { AppFilterFields, SelectOptions } from '../../../interfaces/Common';
import JobCard from '../../../Components/JobCards';
import Filters from '../Filters';
import { getJobs, getJobsApply, getJobsBookmark } from '../../../Utils/apiService';
import { AuthUser } from '../../../interfaces/Contexts';
import { AuthContext } from '../../../Helpers/Contexts/authContext';
import jobImgNoFilter from '../../../Assets/jobnofilter.png';

const SavedJobs = () => {
  const [filterData, setFilterData] = useState<AppFilterFields>({});
  const [appliedData, setAppliedData] = useState([]);
  const {
    state: { user },
  } = useContext(AuthContext);
  const userData = user as AuthUser;
  const [allAppliedData, setAllAppliedData] = useState([]);
  const [selectedValues, setSelectedValues] = useState<{ [key: number]: string }>({});
  const [jobFilterData, setJobFilterData] = useState([]);
  const [locations, setLocations] = useState<Array<SelectOptions>>([]);
  const [filter, setFilter] = useState<boolean>(false);
  const [bookmarksData, setBookmarksData] = useState([]);
  const [allBookmarksData, setAllBookmarksData] = useState([]);

  const handleFilterCells = (data: string, key: string) => {
    const filterJobsSaved = allBookmarksData.filter((job: any) => {
      return job[key]?.toLowerCase().includes(data.toLowerCase());
    });
    setBookmarksData(filterJobsSaved);
    setFilterData({ ...filterData, [key]: data });
  };
  const filterJobs = (jobs: any[], criteria: Record<string, any[]>, name: string) => {
    console.log('Filtering jobs with criteria:', criteria, 'for section:', name);

    const filteredJobs: any = jobs.filter((job: any) =>
      Object.keys(criteria).every((key) => {
        if (key.includes('.')) {
          const [parentKey, childKey] = key.split('.');
          return job[parentKey] && criteria[key].some((value: any) => job[parentKey][childKey] === value);
        }
        return criteria[key].some((value: any) => job[key] === value);
      })
    );

    console.log('Filtered jobs:', filteredJobs);

    setBookmarksData(filteredJobs);
    setSelectedValues([]);
  };

  const handleFilterOpen = () => {
    setFilter(!filter);
  };

  const handleFilterCancellation = () => {
    setFilterData({});
    handleFilterOpen();
  };
  const getJobBookmarkDetails = () => {
    getJobsBookmark(userData.applicantId)
      .then((res) => {
        setBookmarksData(res.data.savedJobs);
        setAllBookmarksData(res.data.savedJobs);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getJobDetails = () => {
    getJobs(userData.applicantId)
      .then((res) => {
        setJobFilterData(res.data);
        const locations = res.data.allJobs.map((job: any) => job.Location__c);
        const uniqueLocations: any = Array.from(new Set(locations.filter((location: any) => location !== null)));
        setLocations(uniqueLocations);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  useEffect(() => {
    getJobBookmarkDetails();
    getJobDetails();
  }, []);

  return (
    <div>
      {' '}
      <Paper
        sx={{
          marginTop: '-20px',
          height: { lg: '85vh', xl: '85vh' },
          boxShadow: 'none',
          borderRadius: 2,
          '@media (min-width: 1280px) and (max-width: 1300px)': {
            height: '82vh !important',
          },
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <SearchBar
              handleDropDownChange={(e) => {
                console.log('7657656', e);
                handleFilterCells(e, 'Location__c');
              }}
              handleSearchChange={(e) => {
                console.log('7657656345', e);
                handleFilterCells(e, 'Job_Title__c');
              }}
              searchBarData={{ dropDown: filterData['Location__c'], input: filterData['Job_Title__c'] }}
              dropDownData={locations}
              handleFilter={handleFilterOpen}
            />
            <Modal open={filter} onClose={handleFilterCancellation} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
              <Filters
                handleClose={handleFilterCancellation}
                jobFilterData={jobFilterData}
                selectedValues={selectedValues}
                setSelectedValues={setSelectedValues}
                handleDropDownChange={(e: any) => {
                  delete e?.Salary;
                  filterJobs(allBookmarksData, e, 'Applied');
                }}
              />
            </Modal>
          </Grid>
        </Grid>
        <Typography style={{ fontSize: '15px', fontWeight: 500, textAlign: 'left', marginLeft: 25 }}>Saved Jobs</Typography>
        <Grid
          container
          spacing={2}
          sx={{
            p: 3,
            mt: 1,
            height: '62vh',
            '@media (min-width: 1280px) and (max-width: 1300px)': {
              height: '53vh !important',
            },
          }}
          className="scrollbar-cusgray"
        >
          {bookmarksData.length > 0 ? (
            <>
              {bookmarksData?.map((val: any) => {
                return (
                  <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                    <JobCard value={val} />
                  </Grid>
                );
              })}
            </>
          ) : (
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
              <Box sx={{ marginTop: '100px' }}>
                <img src={jobImgNoFilter} height={'90px'} width={'78.65px'} />
                <Typography style={{ color: '#373A45', fontSize: '15px', fontWeight: 600 }}>Oops! There are no events with those filters.</Typography>
                <Typography style={{ color: '#373A45', fontSize: '15px', fontWeight: 400 }}>Try with another set of filters.</Typography>
              </Box>
            </Box>
          )}
        </Grid>
      </Paper>
    </div>
  );
};

export default SavedJobs;
